import React from "react";
import { Route } from "react-router-dom";

import Page from "@ROM-pages/CompanyAdmin/Products/Index";
import Layout from "@ROM-pages/Layouts/CompanyAdmin";

class RouteHandler extends Route {
  render() {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  }
}

export default RouteHandler;
